import React from 'react';

function ChatBotIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        fill="#667085"
        d="M6.72656 13.2764V13.7764L8.97656 12.0889C9.22656 11.9014 9.53906 11.7764 9.88281 11.7764H14.2266C14.4766 11.7764 14.7266 11.5576 14.7266 11.2764V2.27637C14.7266 2.02637 14.4766 1.77637 14.2266 1.77637H2.22656C1.94531 1.77637 1.72656 2.02637 1.72656 2.27637V11.2764C1.72656 11.5576 1.94531 11.7764 2.22656 11.7764H5.22656C6.03906 11.7764 6.72656 12.4639 6.72656 13.2764ZM6.69531 15.6826L6.53906 15.7764L6.00781 16.1826C5.85156 16.3076 5.66406 16.3076 5.47656 16.2451C5.32031 16.1514 5.22656 15.9951 5.22656 15.7764V15.1201V14.9326V14.9014V14.7764V13.2764H3.72656H2.22656C1.10156 13.2764 0.226562 12.4014 0.226562 11.2764V2.27637C0.226562 1.18262 1.10156 0.276367 2.22656 0.276367H14.2266C15.3203 0.276367 16.2266 1.18262 16.2266 2.27637V11.2764C16.2266 12.4014 15.3203 13.2764 14.2266 13.2764H9.88281L6.72656 15.6514L6.69531 15.6826ZM4.97656 4.77637H11.4766C11.8828 4.77637 12.2266 5.12012 12.2266 5.52637C12.2266 5.96387 11.8828 6.27637 11.4766 6.27637H4.97656C4.53906 6.27637 4.22656 5.96387 4.22656 5.52637C4.22656 5.12012 4.53906 4.77637 4.97656 4.77637ZM4.97656 7.77637H8.47656C8.88281 7.77637 9.22656 8.12012 9.22656 8.52637C9.22656 8.96387 8.88281 9.27637 8.47656 9.27637H4.97656C4.53906 9.27637 4.22656 8.96387 4.22656 8.52637C4.22656 8.12012 4.53906 7.77637 4.97656 7.77637Z"
      />
    </svg>
  );
}
export default ChatBotIcon;
